import { useCallback } from 'react'

import { isAuthenticated, useAuth } from '@suntex.fim/auth/react'
import { playerDashboardPath } from '@suntex.fim/nav'
import { StagesOfLearningProgressPage, usePlayer } from '@suntex.fim/player'

export default function AssessmentReportStagesOfLearning() {
  const { login } = useAuth(isAuthenticated)
  const { isPreview } = usePlayer()

  const getHubHref = useCallback(
    (path: string) =>
      playerDashboardPath(login.entityLevel, login.entityId, isPreview, path),
    [login.entityLevel, login.entityId, isPreview]
  )

  return <StagesOfLearningProgressPage getHubHref={getHubHref} />
}
